export default __webpack_public_path__ + "static/media/instagramIcon.8267756c.svg";